import ButtonTypes from './buttonTypes';

const orderedPartsInclude = {
  SINGLE: 'Single',
  PAIR: 'Pair',
  KIT: 'Kit',
};

export const orderedPartsIncludeInfo = {
  [orderedPartsInclude.SINGLE]: {
    title: 'Single',
    state: ButtonTypes.LIGHT_SUCCESS
  },
  [orderedPartsInclude.PAIR]: {
    title: 'Pair',
    state: ButtonTypes.LIGHT_WARNING
  },
  [orderedPartsInclude.KIT]: {
    title: 'Kit',
    state: ButtonTypes.LIGHT
  },
};

export const orderedPartsIncludeList = [
  { label: orderedPartsInclude.SINGLE, value: orderedPartsInclude.SINGLE },
  { label: orderedPartsInclude.PAIR, value: orderedPartsInclude.PAIR },
  { label: orderedPartsInclude.KIT, value: orderedPartsInclude.KIT },
];
export default orderedPartsInclude;
